import React from "react";
import {Separator} from "@vkontakte/vkui";
import Countdown from "../../components/Countdown/Countdown";
import {timeToMidnight} from "../../utils/time";

const BUTTON_CLASSES = "bg-yellow-400 hover:bg-yellow-500 text-gray-800 border-yellow-400 cursor-pointer";

const BUY_LIVES_BUTTON_CLASSES = {
    enabled: "cursor-pointer bg-yellow-400 hover:bg-yellow-500 border-yellow-400/20 text-gray-800",
    disabled: "cursor-default bg-gray-300 hover:bg-gray-300 border-gray-400/20 text-gray-500",
};

// Обрабатывает нажатия Enter/Space для кастомной кнопки покупки
const handleBuyButtonKeyDown = (event, canBuy, onBuy, onCannotBuy) => {
    if (event.key !== "Enter" && event.key !== " ") {
        return;
    }
    event.preventDefault();
    if (canBuy) {
        onBuy();
        return;
    }
    onCannotBuy();
};

// AttemptsPanel показывает блок старта игры или покупки жизней, опционально с таймером
const AttemptsPanel = ({
                           dailyAttemptPrice,
                           canBuy,
                           onBuy,
                           availableAttempts,
                           onStart,
                           title,
                           description,
                           withCountdown,
                           onCannotBuy,
                       }) => {
    return (
        <div
            className="flex flex-col mx-auto pt-3 py-4 items-center justify-center w-full bg-gray-800 rounded-xl px-4 gap-3">
            {withCountdown && (
                <>
                    <Countdown date={timeToMidnight()}/>
                    <Separator/>
                </>
            )}
            {availableAttempts > 0 ? (
                <div className="flex flex-col items-center gap-2 w-full max-w-sm">
                    <Button
                        size="s"
                        mode="primary"
                        stretched
                        className={`${BUTTON_CLASSES}`}
                        onClick={onStart}
                    >
                        Start new game
                    </Button>
                    <div className="text-sm text-gray-500 text-center">
                        Start a new game and beat your result 😉
                    </div>
                    <div className="text-xs text-gray-300">
                        {availableAttempts} {availableAttempts === 1 ? "life remains" : "lives remain"}
                    </div>
                </div>
            ) : (
                <div className="flex flex-col items-center gap-2 w-full max-w-sm">
                    <div
                        role="button"
                        tabIndex={0}
                        aria-disabled={!canBuy}
                        className={
                            "border-solid border-2 rounded-lg px-3 py-1 w-full text-sm " +
                            (canBuy ? BUY_LIVES_BUTTON_CLASSES.enabled : BUY_LIVES_BUTTON_CLASSES.disabled)
                        }
                        onClick={canBuy ? onBuy : onCannotBuy}
                        onKeyDown={(event) => handleBuyButtonKeyDown(event, canBuy, onBuy, onCannotBuy)}
                    >
                        <div className="flex flex-col items-center justify-center text-center leading-5">
                            <div className="text-sm">Refill lives</div>
                            <div className="text-xs">
                                3 <span className="leading-none">❤️</span> for {dailyAttemptPrice} {dailyAttemptPrice === 1 ? "coin" : "coins"}
                            </div>
                        </div>
                    </div>
                    <div className="text-sm text-gray-300 text-center">{title}</div>
                    <div className="text-xs text-gray-500 text-center">{description}</div>
                </div>
            )}
        </div>
    );
};

export default AttemptsPanel;
